import { SerializedFile } from "../serializedFile";

export interface RepFieldAudit {
	representativeFieldAuditId: number;
	createdOn: Date;
	updatedOn: Date;
	representativeId?: number;
	qaAnalystId: number;
	qaAnalyst: string;
	auditDate: Date;
	auditType?: number;
	auditTypeId: number;
	auditTypeName: string;
	formTypeId: number;
	formTypeName: string;
	agentName: string;
	agentId: number;
	channel: string;
	brand: string;
	marketer: string;
	pass: boolean;
	permitApproved: boolean;
	noShow: boolean;
	witnessSale: boolean;
	officeVisit: boolean;
	issues: boolean;
	ghostBadging: boolean;
	score?: number;
	scoreAmount?: number;
	scoreTotal?: number;
	scorePercentage?: string;
	retailShopType?: number;
	locationId?: number;
	locationName: string;
	time: string;
	showScore: boolean;
	comments: string;
	evaluationId: number;
	evaluationLink: string;
	complaintNotes: string;
	complaintTypeId?: number;
	operationStart: string;
	operationEnd: string;
	scoreNotes: string;
	questionGroups: RepFieldAuditQuestionGroup[];
	responses: Partial<RepFieldAuditQuestion>[];
	responseMap: {
		[key: number]: {
			[key: string]: string | number | SerializedFile;
		};
	};

	isLocationPortal?: boolean;

	lat?: number;
	lon?: number;
	acc?: number;
}

export interface RepFieldAuditQuestionGroup {
	groupName: string;
	questions: RepFieldAuditQuestion[];
}

export interface RepFieldAuditQuestion {
	representativeFieldAuditQuestionId: number;
	representativeFieldAuditId: number;
	response: string | number | null;
	file: SerializedFile;
	questionText: string;
	questionType: QuestionType;
	score?: number;
	dropDownAction: string;
	parentQuestionId?: number;
	parentQuestionConditionResponse: string;
}

export enum QuestionType {
	YesNoNA = 1,
	YesNoNotApplicable = 2,
	FreeResponse = 3,
	CustomDropDown = 4,
	MultiSelectDropDown = 5,
	Date = 6,
	Time = 7,
	PhotoUpload = 8,
	YesNo = 9,
}

export interface RepFieldAuditHistory {
	id: number;
	user: string;
	lat: number;
	lon: number;
	acc: number;
	comments: string;
	createdOn: Date;
}

export interface RepFieldAuditQuestionOption {
	id: number;
	value: string;
	ordinal: number;
	score: number | null;
}
